export const handleUnauthorized = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("userData");
  localStorage.removeItem("userPreferences");

  window.location.href = "/login";
};
